export default __webpack_public_path__ + "static/media/title_vi_sp.fd43b08b.png";